"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoType;
(function (VideoType) {
    VideoType["Raw"] = "raw";
    VideoType["YouTube"] = "youtube";
})(VideoType || (VideoType = {}));
